(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodElmFloatInvisible', sodElmFloatInvisible);

    function sodElmFloatInvisible() {
        return {
            restrict: 'E',
            controller: sodElmFloatInvisibleCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };
    }

    function sodElmFloatInvisibleCtrl($scope, $window, $compile, $element) {
        this.$onInit = function() {
            onScrollCheckVisibility();
        }

        function checkVisible(elm) {
            var rect = elm.getBoundingClientRect();
            var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
            return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
        }

        function floatTheElm(isCurrentlyVisible) {
            if (!isCurrentlyVisible) {
                $element[0].style.display = 'block';
            } else {
                $element[0].style.display = 'none';
            }
        }

        function onScrollCheckVisibility() {
            var parentElm = $element[0].parentElement;
            var isCurrentlyVisible = checkVisible(parentElm);

            floatTheElm(isCurrentlyVisible);
        }

        $window.addEventListener('scroll', function(e) {
            onScrollCheckVisibility();
        });

        $window.addEventListener('resize', function(e) {
            onScrollCheckVisibility();
        });
    }
})();